export interface Category {
  id: string;
  name: string;
  url: string;
}

export const categories: Category[] = [
  { id: 'shoes', name: 'Schuhe', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { id: 'hoodies', name: 'Hoodies & Pullover', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { id: 'tshirts', name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { id: 'jackets', name: 'Jacken', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { id: 'pants', name: 'Hosen & Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { id: 'headwear', name: 'Kopfbedeckung', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { id: 'sets', name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { id: 'underwear', name: 'Unterwäsche', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { id: 'jersey', name: 'Trikots', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { id: 'accessories', name: 'Accessoires', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { id: 'bags', name: 'Taschen', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { id: 'belts', name: 'Gürtel', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { id: 'perfumes', name: 'Parfums', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { id: 'other', name: 'Sonstiges', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];